var React = require('react');

function TwitterCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M256 0c141.385 0 256 114.615 256 256S397.385 512 256 512 0 397.385 0 256 114.615 0 256 0z","key":0}),React.createElement("path",{"fill":"#fff","fillRule":"nonzero","d":"M318.64 157.549h33.401l-72.973 83.407 85.85 113.495h-67.222l-52.647-68.836-60.242 68.836h-33.423l78.052-89.212-82.354-107.69h68.924l47.59 62.917 55.044-62.917zm-11.724 176.908h18.51L205.95 176.493h-19.86l120.826 157.964z","key":1})]);
}

TwitterCircle.defaultProps = {"shapeRendering":"geometricPrecision","textRendering":"geometricPrecision","imageRendering":"optimizeQuality","fillRule":"evenodd","clipRule":"evenodd","viewBox":"0 0 512 512"};

module.exports = TwitterCircle;

TwitterCircle.default = TwitterCircle;
